import "core-js/modules/es.object.get-own-property-descriptor.js";
import _classCallCheck from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/data/landun/workspace/b-b500fbb73f7c4dbc898306ee34f35371/codebase/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _window$setting$口令分享, _class;

import { lock } from '@/util/decorator';
import { request } from './util';
var baseUrl = '//vip.video.qq.com/fcgi-bin/comm_cgi';
var pageId = ((_window$setting$口令分享 = window.setting.口令分享) === null || _window$setting$口令分享 === void 0 ? void 0 : _window$setting$口令分享.口令ID) || '2001';
var Service = (_class = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);
  }

  _createClass(Service, null, [{
    key: "getScore",
    value:
    /**
     * 获取用户积分
     */
    function getScore() {
      var options = {
        name: 'get_cscore',
        type: 1
      };
      return request({
        retry: 1
      })(baseUrl, options);
    }
    /**
     * 获取短链
     * @param {String} url 目标链接
     */

  }, {
    key: "getShortUrl",
    value: function getShortUrl(url) {
      var options = {
        name: 'short_url',
        need_short_url: 1,
        is_share: 1,
        margin: 1,
        url: url
      };
      return request({
        retry: 2
      })(baseUrl, options);
    }
    /**
     * 生成口令
     * @param {String} url 目标链接
     */

  }, {
    key: "getPassword",
    value: function getPassword(url) {
      var options = {
        name: 'spp_magic_activity_kouling',
        cmd: 1,
        pageid: pageId,
        jumpurl: url
      };
      return request({
        retry: 2
      })(baseUrl, options);
    } // static inviteOpenVip() {
    //   const options = {
    //     name: 'invite_createpackage',
    //     cmd: 4353,
    //     actid: 'HLW_9544AR',
    //   };
    //   return request()(baseUrl, options);
    // }

  }]);

  return Service;
}(), (_applyDecoratedDescriptor(_class, "getScore", [lock], Object.getOwnPropertyDescriptor(_class, "getScore"), _class)), _class);
export default Service;